/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Formulas_ExampleInputs */

const en_gc_guides_formulas_example = /** @type {(inputs: Gc_Guides_Formulas_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter each formula in its own cell. Comments explain the expected results.`)
};

const zh_gc_guides_formulas_example = /** @type {(inputs: Gc_Guides_Formulas_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分别将公式输入单元格，注释说明预期结果。`)
};

/**
* | output |
* | --- |
* | "Enter each formula in its own cell. Comments explain the expected results." |
*
* @param {Gc_Guides_Formulas_ExampleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_formulas_example = /** @type {((inputs?: Gc_Guides_Formulas_ExampleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Formulas_ExampleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_formulas_example(inputs)
	return zh_gc_guides_formulas_example(inputs)
});
export { gc_guides_formulas_example as "gc.guides.formulas.example" }